import { useNavigate, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faUser,
  faBriefcase,
  faFileLines,
  faUsers,
  faCreditCard,
  faMoneyBill,
  faRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

function Sidebar() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/employer/login"); // redirect to login page
  };

  if (!token) return null; // hide sidebar if not logged in

  return (
    <div className="panelSidebar">
      <ul className="mainsidebar">
        <li>
          <NavLink
            to="/employer/dashboard"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faHouse} className="sidebar-icon" />
            Dashboard
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/employer/profile"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faUser} className="sidebar-icon" />
            Profile
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/employer/job-list"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faBriefcase} className="sidebar-icon" />
            My Job Post
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/employer/job-applications"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faFileLines} className="sidebar-icon" />
            Job Applications
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/employer/connected-candidates"
            className={({ isActive }) =>
              isActive ||
              window.location.pathname.startsWith("/employer/task-list")
                ? "active"
                : ""
            }
          >
            <FontAwesomeIcon icon={faUsers} className="sidebar-icon" />
            Connected Candidates
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/employer/make-payment"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faCreditCard} className="sidebar-icon" />
            Make Payment
          </NavLink>
        </li>

        <li>
          <NavLink
            to="/employer/payment-history"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            <FontAwesomeIcon icon={faMoneyBill} className="sidebar-icon" />
            Payment History
          </NavLink>
        </li>

        <li>
          <button
            type="button"
            onClick={handleLogout}
            style={{
              backgroundColor: "inherit",
              border: "none",
              cursor: "pointer",
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/icons/logout.svg`}
              alt="ico"
              width="12px"
            />{" "}
            Logout
          </button>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;
